import React from 'react';
import styled from 'styled-components';

import { Container, Typography } from '@material-ui/core/';

import CardWrapper from '../components/common/CardWrapper';

const Root = styled(Container)`
	h2,
	h3 {
		margin: 40px 0 10px 0;
	}

	h1 {
		font-size: 48px;
	}

	h2 {
		font-size: 20px;
		text-transform: uppercase;
		font-weight: bold;
	}

	h3 {
		font-size: 18px;
		font-weight: bold;
	}
`;

const PageImprint = () => (
	<Root maxWidth="lg">
		<CardWrapper>
			<Typography variant="h1">Impressum</Typography>
			<Typography variant="h2">Herausgeber:</Typography>
			<Typography>be.storaged GmbH</Typography>
			<Typography variant="h3">Besucheradresse:</Typography>
			<Typography>Fritz-Bock-Straße 5</Typography>
			<Typography>26121 Oldenburg</Typography>
			<Typography variant="h3">Postadresse und Sitz der Gesellschaft:</Typography>
			<Typography>Tirpitzstraße 39</Typography>
			<Typography>26122 Oldenburg</Typography>
			<Typography variant="h3">Kontakt:</Typography>
			<Typography>Tel.: +49 (0) 441 351 197-0</Typography>
			<Typography>E-Mail: info@be-storaged.com</Typography>
			<Typography>
				Website:{' '}
				<a
					href="http://www.be-storaged.com"
					target="_blank"
					rel="noopener noreferrer"
				>
					http://www.be-storaged.com
				</a>
			</Typography>
			<Typography variant="h2">EWE Aktiengesellschaft</Typography>
			<Typography>26122 Oldenburg</Typography>
			<Typography>Tel.: +49 441 4805-0</Typography>
			<Typography>Fax: +49 441 803-3999</Typography>
			<Typography>E-Mail: info@ewe.de</Typography>
			<Typography>
				{' '}
				<a href="http://www.ewe.de/ " target="_blank" rel="noopener noreferrer">
					http://www.ewe.de/
				</a>
			</Typography>
			<Typography variant="h2">Vertreten durch:</Typography>
			<Typography>Hendrik Brockmeyer und Dr. Magnus Pielke</Typography>
			<Typography variant="h2">Gerichtsstand:</Typography>
			<Typography>Amtsgericht Oldenburg, HRB 204257</Typography>
			<Typography variant="h2">Umsatzsteueridentifikationsnummern:</Typography>
			<Typography>DE315640644 (be.storaged GmbH)</Typography>
			<Typography>DE117471330 (EWE Aktiengesellschaft)</Typography>
			<Typography variant="h2">Bankverbindung der be.storaged GmbH:</Typography>
			<Typography>Oldenburgische Landesbank AG</Typography>
			<Typography>BLZ: 280 200 50</Typography>
			<Typography>Kto.: 1427962400</Typography>
			<Typography>IBAN: DE57 2802 0050 1427 9624 00</Typography>
			<Typography>BIC: OLBODEH2XXX</Typography>
			<Typography variant="h2">Bankverbindung EWE Aktiengesellschaft:</Typography>
			<Typography>Oldenburgische Landesbank AG</Typography>
			<Typography>BLZ: 280 200 50</Typography>
			<Typography>Kto.: 142 21956 00</Typography>
			<Typography>IBAN: DE33 2802 0050 1422 1956 00</Typography>
			<Typography>BIC: OLBODEH2XXX</Typography>
			<Typography variant="h2">Datenschutzbeauftragter:</Typography>
			<Typography>Uwe Kettler</Typography>
			<Typography>E-Mail: datenschutz@ewe.de</Typography>
			<Typography variant="h3">
				Hier finden Sie die Datenschutzerklärung der EWE AG.
			</Typography>
			<Typography>
				Verantwortliche im Sinne des Presserechts: Corinna Heße
			</Typography>
			<Typography>E-Mail: corinna.hesse@ewe.de</Typography>
			<Typography variant="h2">
				Haltung der EWE Aktiengesellschaft zu externen Links:
			</Typography>
			<Typography>
				Die externen Links des Internetangebotes der be.storaged GmbH vermitteln
				den Zugang zur Nutzung von Angeboten fremder Dienstanbieter. be.storaged
				übernimmt für den Inhalt externer Links keine Verantwortung. Sollte eine
				URL nicht mehr erreichbar sein, benachrichtigen Sie uns bitte per E-Mail.
			</Typography>
			<Typography variant="h2">Sitz der Gesellschaft:</Typography>
			<Typography>Oldenburg</Typography>
			<Typography>Handelsregister: Amtsgericht Oldenburg, HRB 3723</Typography>
			<Typography>Umsatzsteueridentifikationsnummer: DE 184286895</Typography>
			<Typography variant="h2">
				Konzeption, Redaktion und Verantwortung für den Inhalt:
			</Typography>
			<Typography>EWE Aktiengesellschaft</Typography>
			<Typography>Tirpitzstraße 39</Typography>
			<Typography>26122 Oldenburg</Typography>
			<Typography>Tel.: +49 441 4805-0</Typography>
			<Typography>Fax: +49 441 4805-3999</Typography>
			<Typography>E-Mail: info@ewe.de</Typography>
			<Typography>
				{' '}
				<a href="http://www.ewe.de/ " target="_blank" rel="noopener noreferrer">
					http://www.ewe.de/
				</a>
			</Typography>
			<Typography variant="h3">be.storaged GmbH</Typography>
			<Typography>Tirpitzstraße 39</Typography>
			<Typography>26122 Oldenburg</Typography>
			<Typography>E-Mail: info@be-storaged.com</Typography>
			<Typography>
				{' '}
				<a
					href="http://www.be-storaged.com"
					target="_blank"
					rel="noopener noreferrer"
				>
					http://www.be-storaged.com
				</a>
			</Typography>
		</CardWrapper>
	</Root>
);

export default PageImprint;
